import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const LoginPage = lazy(() => import('../pages/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/page'));
const AdminStoresPage = lazy(() => import('../pages/admin/stores/page'));
const NewStorePage = lazy(() => import('../pages/admin/stores/new/page'));
const EditStorePage = lazy(() => import('../pages/admin/stores/edit/page'));
const StoreFacilityPage = lazy(() => import('../pages/admin/stores/facility/page'));
const StoreOperationsPage = lazy(() => import('../pages/admin/stores/operations/page'));
const AccountsPage = lazy(() => import('../pages/admin/accounts/page'));
const NewAccountPage = lazy(() => import('../pages/admin/accounts/new/page'));
const EditAccountPage = lazy(() => import('../pages/admin/accounts/edit/page'));
const AssignStorePage = lazy(() => import('../pages/admin/accounts/assign/page'));
const EquipmentPage = lazy(() => import('../pages/admin/equipment/page'));
const AdminMonitoringPage = lazy(() => import('../pages/admin/monitoring/page'));
const AdminAnalyticsPage = lazy(() => import('../pages/admin/analytics/page'));
const StoreTypesPage = lazy(() => import('../pages/admin/store-types/page'));
const ServerStatusPage = lazy(() => import('../pages/admin/server-status/page'));
const FirmwareVersionsPage = lazy(() => import('../pages/admin/firmware/versions/page'));
const FirmwareDeploymentsPage = lazy(() => import('../pages/admin/firmware/deployments/page'));
const FirmwareLogsPage = lazy(() => import('../pages/admin/firmware/logs/page'));
const FirmwareGroupsPage = lazy(() => import('../pages/admin/firmware/groups/page'));
const SettlementsPage = lazy(() => import('../pages/admin/settlements/page'));
const ReservationsPage = lazy(() => import('../pages/admin/reservations/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LoginPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/admin',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/stores',
    element: <AdminStoresPage />,
  },
  {
    path: '/admin/store-types',
    element: <StoreTypesPage />,
  },
  {
    path: '/admin/stores/new',
    element: <NewStorePage />,
  },
  {
    path: '/admin/stores/:id/edit',
    element: <EditStorePage />,
  },
  {
    path: '/admin/stores/facility',
    element: <StoreFacilityPage />,
  },
  {
    path: '/admin/stores/operations',
    element: <StoreOperationsPage />,
  },
  {
    path: '/admin/monitoring',
    element: <AdminMonitoringPage />,
  },
  {
    path: '/admin/accounts',
    element: <AccountsPage />,
  },
  {
    path: '/admin/accounts/new',
    element: <NewAccountPage />,
  },
  {
    path: '/admin/accounts/:userId/edit',
    element: <EditAccountPage />,
  },
  {
    path: '/admin/accounts/:userId/assign',
    element: <AssignStorePage />,
  },
  {
    path: '/admin/equipment',
    element: <EquipmentPage />,
  },
  {
    path: '/admin/analytics',
    element: <AdminAnalyticsPage />,
  },
  {
    path: '/admin/server-status',
    element: <ServerStatusPage />,
  },
  {
    path: '/admin/firmware/versions',
    element: <FirmwareVersionsPage />,
  },
  {
    path: '/admin/firmware/deployments',
    element: <FirmwareDeploymentsPage />,
  },
  {
    path: '/admin/firmware/logs',
    element: <FirmwareLogsPage />,
  },
  {
    path: '/admin/firmware/groups',
    element: <FirmwareGroupsPage />,
  },
  {
    path: '/admin/settlements',
    element: <SettlementsPage />,
  },
  {
    path: '/admin/reservations',
    element: <ReservationsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
